import React, { useEffect, useState, useContext } from "react";
import Icon from "@mdi/react";
import { mdiVote } from "@mdi/js";
import { GET } from "../../utils/fetchUtil";
import { useTranslation, Trans } from "react-i18next";
import ElectionDashboard from "../requests/elections/electionsPanel/ElectionsDashboard";
import { MessageContext } from "../../common/message/index";
import Box from "../../common/box/Box";
import { isDesktop } from "../../utils/screenUtil";
import { cleanJoin } from "../../utils/stringUtil";
import ElectionTitle from "./elections/customModals/ElectionTitle";

const RequestVotingPage = () => {
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const [elections, setElection] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [activeElection, setActiveElection] = useState(false);

  const STATUS = {
    uPlaniranju: 1,
    zakljucano: 2,
    uTijeku: 3,
    zavrseno: 4,
    otkazano: 5,
  };

  useEffect(() => {
    GET(
      "/elections",
      (requests) => {
        setElection(requests);
        let active = new Array();
        active = requests.filter(
          (req) =>
            req.generatedStatus.id === STATUS.uTijeku ||
            req.generatedStatus.id === STATUS.uPlaniranju ||
            req.generatedStatus.id === STATUS.zakljucano
        );
        if (active.length > 0) setActiveElection(true);
      },
      (error) => {
        setElection(error);
        message.toggle({
          title: t("requests.overview.supplement.infoBar.errorTitle"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, [refresh]);

  return (
    <>
      <ElectionTitle />

      <div className="columns">
        <div className="column is-three-fifths is-offset-one-fifth">
          {!activeElection && (
            <Box
              className="electionPanel"
              statusIndicatorColor="purple-dark"
              statusIndicatorPosition="bottom"
              isShadowless="false"
              defaultPadding="false"
            >
              <div className="is-flex is-justify-content-center is-align-self-center p-6 has-text-purple-dark is-size-3">
                {t("voting.noActiveElections")}
              </div>
            </Box>
          )}
          {elections.length > 0 &&
            elections.map((election, index) => {
              return (
                <ElectionDashboard
                  election={election}
                  key={index}
                  refresh={refresh}
                  setRefresh={setRefresh}
                />
              );
            })}
        </div>
      </div>
    </>
  );
};

export default RequestVotingPage;
